const DB_NAME = "starsprodb";
const DB_VERSION = "1";

const TOAST_CONFIG = {
  position: "top-right",
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  toastId: Math.floor(Math.random() * 9999) + 1,
};

const LOGO = `/logo192.png`;
export const LOGO_DESKTOP = `/logo512.png`;

export const MODAL_KEYS = {
  SHEET: "sheet",
  MODAL: "modal",
  FILTERS: "filters",
  CONFIRMATION: "confirmation",
  PROPERTY_TRANSFER: "property_transfer",
  AMENITY_ACCESS: "amenity_access",
  TURNOVER: "turnover",
  OCCUPANT_INVITE: "occupant_invite",
  OCCUPANT_REVOKE: "occupant_revoke",
  DEACTIVATE: "deactivate",
  REACTIVATE: "reactivate",
};

export const CITATION_BY = ["Household", "Plate"];

export const CITATION_APPLY_BY = ["Individual rules", "All the same"];

export const CITATION_PERIOD = ["Rolling window", "Calendar Month", "Calendar Year"];

export const SAFELISTING_BY = ["Household", "Plate"];

export const SAFELISTING_PERIOD = ["Rolling window", "Calendar Month", "Calendar Year"];

export const COUNT_TO_TOW = ["Yes", "No"];

export {DB_NAME, DB_VERSION, TOAST_CONFIG, LOGO};
